import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

import { BuildingList, Dialog, DialogContent, DialogTitle, Loading } from 'components';
import { EBuildingListDisplayMode } from 'enums';
import { useBuildingItems } from 'pages/buildings/buildings.hook';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { ROUTES } from 'consts';

interface BuildingSelectDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  buildingId: number;
}

export const BuildingSelectDialog = ({
  visible = false,
  setVisible = () => {},
  buildingId,
}: BuildingSelectDialogProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [loading, buildings] = useBuildingItems({ searchKeyword: '' });
  const navigate = useNavigate();

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  return (
    <Dialog onClose={onClose} open={visible}>
      <DialogTitle>
        <Box marginTop={4}>
          <Typography variant="h5">Select a Building</Typography>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ paddingY: 2 }}>
          {loading ? (
            <Loading text="Loading buildings..." height={240} />
          ) : (
            <BuildingList
              buildings={buildings}
              selectedBuildingId={buildingId}
              mode={EBuildingListDisplayMode.LIST}
              onBuildingItem={(buildingId) => {
                navigate(`/${orgSlug}/${ROUTES.DASHBOARD}/${buildingId}`);
                setVisible(false);
              }}
            />
          )}
        </Box>
      </DialogContent>

      <Box position="absolute" display="flex" right={16} top={16}>
        <IconButton color="primary" onClick={() => onClose(null, 'anyway')}>
          <Close />
        </IconButton>
      </Box>
    </Dialog>
  );
};
